import { Component, OnDestroy, OnInit, HostBinding, HostListener, ViewEncapsulation, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';

import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { AuthenticationService } from '../../../../app/auth/service';
import { CoreSidebarService } from '@core/components/core-sidebar/core-sidebar.service';
import { CoreConfigService } from '@core/services/config.service';
import { CoreMediaService } from '@core/services/media.service';
import { CustomerService } from "../../../../services/customer.service";

import { User } from 'app/auth/models';
import { first } from 'rxjs/operators';

import { coreConfig } from 'app/app-config';
import { Router, ActivatedRoute } from "@angular/router";
import { UserService } from '../../../auth/service/user.service';
import { ToastrService } from 'ngx-toastr';
import { SharedLocationService } from 'services/shared-location.service';

import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2";

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavbarComponent implements OnInit, OnDestroy {

  @ViewChild("modalOffer", { static: true })
  modalOffer: any;

  public horizontalMenu: boolean;
  public hiddenMenu: boolean;
  public loadingButton: boolean = false;

  public coreConfig: any;
  public currentSkin: string;
  public prevSkin: string;

  public currentUser: User;

  public isActive: boolean = true;
  
  public type = "";
  public offer:any = {
    id:"",
    image: "assets/images/icons/rocket.png",
    title: "",
    subtitle: "",
    description: "",
    benefits: [],
    guarantees:"",
    accepted: true,
    denied:true,
    buttons:{
      accept_text:"",
      accept_link:"",
      deny_text:"",
      deny_link:""
    },
    price:{
      description:"",
      value:"",
      discount:"",
      final_value:""
    }
  };

  public modalRef: NgbModalRef | null = null;

  public isSmallScreen: boolean = false;

  public languageOptions: any;
  public navigation: any;
  public selectedLanguage: any;

  @HostBinding('class.fixed-top')
  public isFixed = false;

  @HostBinding('class.navbar-static-style-on-scroll')
  public windowScrolled = false;

  // Add .navbar-static-style-on-scroll on scroll using HostListener & HostBinding
  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (
      (window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop > 100) &&
      this.coreConfig.layout.navbar.type == 'navbar-static-top' &&
      this.coreConfig.layout.type == 'horizontal'
    ) {
      this.windowScrolled = true;
    } else if (
      (this.windowScrolled && window.pageYOffset) ||
      document.documentElement.scrollTop ||
      document.body.scrollTop < 10
    ) {
      this.windowScrolled = false;
    }
  }

  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {Router} _router
   * @param {AuthenticationService} _authenticationService
   * @param {CoreConfigService} _coreConfigService
   * @param {CoreSidebarService} _coreSidebarService
   * @param {CoreMediaService} _coreMediaService
   * @param {MediaObserver} _mediaObserver
   * @param {TranslateService} _translateService
   */
  constructor(
    private _router: Router,
    private _authenticationService: AuthenticationService,
    private _coreConfigService: CoreConfigService,
    private _coreMediaService: CoreMediaService,
    private _coreSidebarService: CoreSidebarService,
    private _mediaObserver: MediaObserver,
    public _translateService: TranslateService,
    public _userService: UserService,
    private _customersService: CustomerService,
    private _toastrService: ToastrService,
    private _modalService: NgbModal,
    private _route: ActivatedRoute,
    private _sharedLocationService: SharedLocationService
  ) {
    this._authenticationService.currentUser.subscribe(x => (this.currentUser = x));

    this.languageOptions = {
      en: {
        title: 'English',
        flag: 'us'
      },
      fr: {
        title: 'French',
        flag: 'fr'
      },
      de: {
        title: 'German',
        flag: 'de'
      },
      pt: {
        title: 'Portuguese',
        flag: 'pt'
      }
    };

    // Set the private defaults
    this._unsubscribeAll = new Subject();
  }

  // Public Methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle sidebar open
   *
   * @param key
   */
  toggleSidebar(key): void {
    this._coreSidebarService.getSidebarRegistry(key).toggleOpen();
  }

  /**
   * Set the language
   *
   * @param language
   */
  setLanguage(language): void {
    // Set the selected language for the navbar on change
    this.selectedLanguage = language;

    // Use the selected language id for translations
    this._translateService.use(language);

    this._coreConfigService.setConfig({ app: { appLanguage: language } }, { emitEvent: true });
  }

    /**
   * Set the language
   *
   * @param language
   */
    setLocation(locationId): void {
      // Set the selected location for the navbar on change
      // console.log(`Setting location to: ${locationId}`);
      this._authenticationService.setLocation(locationId).then(() => {
        // console.log('location set successfully');
        this._sharedLocationService.emitLocationChange(locationId);
      }).catch(error => {
        console.error('Error setting location:', error);
      });
    }

    getSubscriptionList(){
      this._customersService
      .getSubscriptionList()
      .then((subscriptionList: any) => {
        this.isActive = !subscriptionList[0].active;        
      });
    }

  openPricing(): void {   
    const url = new URL(window.location.href);
    url.searchParams.set('active', '10');    
    if (url.pathname == "/pages/account-settings") {
      // Reload the page with the updated URL
      window.location.href = url.toString();
    }else{
      this._router.navigate(['/pages/account-settings'],{
        queryParams: { active: '10' }
      });
    }
  };
               
  /**
   * Toggle Dark Skin
   */
  toggleDarkSkin() {
    
    // Get the current skin
    this._coreConfigService
      .getConfig()
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(config => {
        this.currentSkin = config.layout.skin;
      });

    // Toggle Dark skin with prevSkin skin
    this.prevSkin = localStorage.getItem('prevSkin');

    if (this.currentSkin === 'dark') {
      this._coreConfigService.setConfig(
        { layout: { skin: this.prevSkin ? this.prevSkin : 'default' } },
        { emitEvent: true }
      );
    } else {
      localStorage.setItem('prevSkin', this.currentSkin);
      this._coreConfigService.setConfig({ layout: { skin: 'dark' } }, { emitEvent: true });
    }
  }

  /**
   * Logout method
   */
  logout() {
    this._authenticationService.logout();
    this._router.navigate(['/pages/authentication/login-v2']);
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // get the currentUser details from localStorage
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));    
    if (this.currentUser != null) {
      this.getSubscriptionList();
      this._customersService.hasOffer()
      .then((response) => {
        if (response != null) {
          this.offer = response;
          var pathname = String(window.location.pathname);     
          
          if((this.offer.denied == false) && (this.offer.accepted == false) && (pathname == "/dashboard/home")){
            this.offerViewer();
          };
        };
      })
      .catch((error) => {
        console.error("Error fetching updated data:", error);
      });
    }
    // Subscribe to the config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
      this.horizontalMenu = config.layout.type === 'horizontal';
      this.hiddenMenu = config.layout.menu.hidden === true;
      this.currentSkin = config.layout.skin;

      // Fix: for vertical layout if default navbar fixed-top than set isFixed = true
      if (this.coreConfig.layout.type === 'vertical') {
        setTimeout(() => {
          if (this.coreConfig.layout.navbar.type === 'fixed-top') {
            this.isFixed = true;
          }
        }, 0);
      }
    });

    // Horizontal Layout Only: Add class fixed-top to navbar below large screen
    if (this.coreConfig.layout.type == 'horizontal') {
      // On every media(screen) change
      this._coreMediaService.onMediaUpdate.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
        const isFixedTop = this._mediaObserver.isActive('bs-gt-xl');
        if (isFixedTop) {
          this.isFixed = false;
        } else {
          this.isFixed = true;
        }
      });
    }

    // Set the selected language from default languageOptions
    this.selectedLanguage = _.find(this.languageOptions, {
      id: this._translateService.currentLang
    });

  }

  checkScreenSize() {
    this.isSmallScreen = window.innerWidth < 600;

    setTimeout(() => {
      
      if(this.isSmallScreen == false){
        var offer_title = <HTMLElement> document.getElementById("offer_title");
        var offer_subtitle = <HTMLElement> document.getElementById("offer_subtitle");
        var offer_description = <HTMLElement> document.getElementById("offer_description");
        var offer_guarantees = <HTMLElement> document.getElementById("offer_guarantees");
        var offer_price_description = <HTMLElement> document.getElementById("offer_price_description");
        var offer_buttons_accept = <HTMLElement> document.getElementById("offer_buttons_accept");
        var offer_buttons_deny = <HTMLElement> document.getElementById("offer_buttons_deny");
  
        offer_title.innerHTML = this.offer.title;
        offer_subtitle.innerHTML = this.offer.subtitle;
        offer_description.innerHTML = this.offer.description;
        offer_guarantees.innerHTML = this.offer.guarantees;
        offer_price_description.innerHTML = this.offer.price.description
        offer_buttons_accept.innerHTML = this.offer.buttons.accept_text
        offer_buttons_deny.innerHTML = this.offer.buttons.deny_text
    
        this.type = String(this._route.snapshot.queryParams["type"]) || String("");  
    
        if(this.type == "accelerator"){      
          var offer_buttons_accept = <HTMLElement> document.getElementById("offer_buttons_accept");
          offer_buttons_accept.click()
        }    
      };
    }, 100);


  }

  onResize = () => {
    this.checkScreenSize();

  };

  offerViewer(){
    this.modalRef = this._modalService.open(this.modalOffer, {
      centered: true,
      size: "xl", // size: 'xs' | 'sm' | 'lg' | 'xl'
    });
    
      // Add event listener
    window.addEventListener('resize', this.onResize);
    this.checkScreenSize(); // Check on open



    // Remove event listener when modal closes
    this.modalRef.result.finally(() => {
      window.removeEventListener('resize', this.onResize);
    });
  }

  acceptOffer(): void{
    this.loadingButton = true

    this._customersService
      .getStatement()
      .then((result: any) => {
        if (result.paymentMethod.length > 0) {
          for (var i = 0; i < result.paymentMethod.length; ++i) {
            var element = result.paymentMethod[i];
            if(element.primary_method == true){
              Swal.fire({
                title: "PROCEED TO CHECKOUT",
                text: "Use your registered payment method to complete the transaction?",
  
                html: `
                    <p>Use your registered payment method to complete the transaction?</p>
                    <p><b>Payment Method:</b> ${element.type}</p>
                    <p><b>Last Four Digits:</b> ${element.method_details.last4} </p>`,
  
                confirmButtonText: "Use Current Payment Method",
                cancelButtonText: "Add New Payment Method",
                showCancelButton: true,
  
                customClass: { 
                  confirmButton: "btn btn-success",
                  cancelButton: "btn btn-primary ml-1",
                  },

                }).then((data) => {    
                  this.loadingButton = false;

                  if (data.isConfirmed == true) {
                    this._customersService
                    .acceptOffer(this.offer.id, 'accepted')
                    .then((result: any) => {
                      this._modalService.dismissAll();
                      this.loadingButton = false;                    

                      switch (result.status) {
                        case "succeeded":
                          Swal.fire({
                            icon: 'success',
                            title: 'Offer activated',
                            html: `
                              <p>${result.message}</p>
                              <p><b>Invoice:</b>                          
                                ${result.invoice_id}
                              </p>
                              <p><b>Paid now:</b> $${(result.amount.value - result.amount.discount).toFixed(2)}</p>
      
                            `,
                            confirmButtonText: "Open Invoice",
                            cancelButtonText: "Close",
                            showCancelButton: true,
              
                            customClass: { 
                              confirmButton: "btn btn-primary",
                              cancelButton: "btn btn-secondary ml-1",
                      
                              },
              
                          }).then((data) => {
                            const url = new URL(window.location.href);                              
      
                            if (data.isConfirmed == true) {                              
      
                              url.pathname = '/apps/invoice/preview/' + result.invoice_id;
                              url.href = url.origin + url.pathname;
                              url.searchParams.set('type', 'invoice');
      
                            }else{
                              // url.searchParams.set('active', '10');
                            }
                            // Reload the page with the updated URL
                            window.location.href = url.toString();                              
                          })
                          
                          break;
      
                        case "failed":
                          this.loadingButton = false;
      
                          Swal.fire({
                            title: "Error",
                            text: result.message,
                            html:
                              '<div><p>'+ result.message +'<p/></div>',
                            icon: "error",
                            customClass: {
                              confirmButton: "btn btn-secondary",
                            },
                          });
                          break;
      
                        default:
                          break;
                      }
                    },
                    (error) => {
                      Swal.fire({
                        title: "Error",
                        text: error,
                        icon: "error",
                        customClass: {
                          confirmButton: "btn btn-secondary",
                        },
                      });
                    });                    
                  }else {

                    if(data.dismiss === Swal.DismissReason.cancel){
                    var url = new URL(window.location.href);
                    var success_url = new URL(window.location.href);
                    success_url.searchParams.set('type', 'accelerator');
                    this._customersService.addNewPaymentMethod(this.currentUser['customerId'], url, success_url)
                    .then(
                          (data) => {
                            if (data["url"] == null) {
                              Swal.fire({
                                icon: "error",
                                title: "Error",
                                text: data["description"],
                                showConfirmButton: true,
                                allowOutsideClick: function () {
                                  return !Swal.isLoading();
                                },
                              });
                            } else {
                              window.open(data["url"], "_self");
                            }
                          },
                          (error) => {
                          }
                        );               
                  }}
                });
              
              break;
            };
          };

        }else{
          var url = new URL(window.location.href);
          var success_url = new URL(window.location.href);
          success_url.searchParams.set('type', 'accelerator');          
          this._customersService.addNewPaymentMethod(this.currentUser['customerId'], url, success_url)
          .then(
                (data) => {
                  if (data["url"] == null) {
                    Swal.fire({
                      icon: "error",
                      title: "Error",
                      text: data["description"],
                      showConfirmButton: true,
                      allowOutsideClick: function () {
                        return !Swal.isLoading();
                      },
                    });
                  } else {
                    window.open(data["url"], "_self");
                  }
                },
                (error) => {
                }
              );

        };
      });
    
  };

  denyOffer(): void{
    this._modalService.dismissAll();                

    this._customersService
    .acceptOffer(this.offer.id, 'denied')
    .then((result: any) => {
    },
    (error) => {
      Swal.fire({
        title: "Error",
        text: error,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-secondary",
        },
      });
    }); 

  };

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

    /**
   * Print Action
   */
     printAction(content) {
      this._router.navigate(['apps/user/user-new']);
    };
  
}
